import { render, staticRenderFns } from "./mobile-header.vue?vue&type=template&id=5dd0570f&scoped=true&"
import script from "./mobile-header.vue?vue&type=script&lang=js&"
export * from "./mobile-header.vue?vue&type=script&lang=js&"
import style1 from "./mobile-header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0570f",
  null
  
)

export default component.exports